
//  DD/MM/YYYY format
function DateFormat(receivedDate) {
    const date = new Date(receivedDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
}

// 25 Feb 2025 format
function formatDate(isoString) {
    if (!isoString) {
        return "NA";
    }
    let date;
    if (isoString.includes("/") && isoString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const [day, month, year] = isoString.split("/");
        date = new Date(`${year}-${month}-${day}`);
    } else {
        date = new Date(isoString);
    }
    if (isNaN(date.getTime())) {
        return "NA";
    }
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

function formatDateAndTime(dateTime) {
    if (!dateTime) return '';
    const dateObject = new Date(dateTime);
    const options = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };
    return dateObject.toLocaleString('en-GB', options).replace(/(\d{4})/, '$1');
}

export {
    DateFormat, formatDate, formatDateAndTime
};
